import { $api } from "../../../../services/request.config";

const FileSaver = require("file-saver");

// Функция для декодирования filename* из UTF-8
const decodeFilename = (contentDisposition) => {
    if (!contentDisposition) return null;

    // Сначала пытаемся найти filename* (RFC 5987) - правильный формат с кавычками
    const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
    if (filenameStarMatch && filenameStarMatch[1]) {
        try {
            // Декодируем URL-encoded строку
            return decodeURIComponent(filenameStarMatch[1]);
        } catch (e) {
            console.error("Ошибка декодирования filename*:", e);
        }
    }

    // Пробуем найти filename в кавычках
    const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
    if (filenameMatch && filenameMatch[1]) {
        return filenameMatch[1];
    }

    // Пробуем найти filename без кавычек
    const filenameSimpleMatch = contentDisposition.match(/filename=([^;]+)/);
    if (filenameSimpleMatch && filenameSimpleMatch[1]) {
        return filenameSimpleMatch[1];
    }

    return null;
};

export const downloadDocumentThunkAction = (file) => async (dispatch) => {
    try {
        const document = await $api.get(
            `${file.url}`,
            {
                responseType: "blob",
                headers: {
                    "Access-Control-Expose-Headers": "Content-Disposition",
                },
            },
        );

        const contentDisposition = document.headers["content-disposition"];

        let fileName = null;

        if (contentDisposition) {
            fileName = decodeFilename(contentDisposition);
        }

        if (!fileName) {
            if (file.id === 2 || file.id === 3) {
                fileName = `${file.documentName}_${file.name}.sig`;
            } else {
                fileName = `${file.documentName}_${file.name}.${file.extension}`;
            }
        }
        const blob = new Blob([document.data], {
            type: document.headers["content-type"],
        });

        FileSaver.saveAs(blob, fileName);

        //Старая версия  версия
        // const file = await $api(`${url}`, { responseType: "blob" });
        // const blobLink = URL.createObjectURL(
        //     new Blob([file.data], { type: `${file.headers["content-type"]}` }),
        // );
        // window.open(blobLink);

    } catch (e) {
        console.error("Ошибка при скачивании документа:", e);
    }
};
